import { useMemo } from "react";
import { useLocalization } from "../../../hooks/useLocalization";
import { IGameRecord, IPlayer, IPlayerGameStats } from "../../../types/types";
import { formatGameDuration, indexPlayerStats } from "../../../utils/matchGameSides";
import { buildPlayerGraphRows } from "../../../utils/matchGameGraphData";

interface UseMatchGameGraphsArgs {
  game: IGameRecord;
  gameIndex: number;
  rosterByPuuid: Map<string, IPlayer>;
  playerStats: IPlayerGameStats[];
}

export const useMatchGameGraphs = ({
  game,
  gameIndex,
  rosterByPuuid,
  playerStats,
}: UseMatchGameGraphsArgs) => {
  const { strings } = useLocalization();
  const copy = strings.MATCH_DETAIL;

  const statsByPuuid = useMemo(() => {
    const gameStats = playerStats.filter((stat) => stat.riotGameId === game.game_id);
    return indexPlayerStats(gameStats).byPuuid;
  }, [game.game_id, playerStats]);

  const { blue, red } = useMemo(
    () => buildPlayerGraphRows(game, rosterByPuuid, statsByPuuid),
    [game, rosterByPuuid, statsByPuuid],
  );

  const allPlayers = useMemo(() => [...blue, ...red], [blue, red]);

  const gameTitle = copy.GAME_TITLE.replace("{number}", String(gameIndex + 1));
  const duration = formatGameDuration(game.duration);
  const championAlt = (champion: string) =>
    copy.GRAPHS_CHAMPION_ALT.replace("{champion}", champion);

  return {
    copy,
    allPlayers,
    gameTitle,
    duration,
    championAlt,
  };
};
